NS("UI.Widget.Forms");

UI.Widget.Forms.Tabs = Class({

	tabsTemplate: 'UI/Widget/Forms/Control/Tabs/Template',
	tabsContainer: null,
	currentTab: null,
	tabForm: null,
	tabs: [],

	renderTabs: function () {
		this.tabsContainer =  UI.Template.$render(this.tabsTemplate, {
			widget: this
		});
		var self = this;
		this.tabsContainer.find('.tab').on('click', function (e) {
			self.tabShow($(this).attr('name'));
		});

		return this.tabsContainer;
	},

	tabShow: function (name) {
		if (name) {
			this.currentTab = _.find(this.tabs, {name: name});
		}
		if (this.tabsContainer.find('[name=' + name + ']').hasClass('active')) return this;

		if (this.currentTab) {
			this.tabsContainer.find('.tab').removeClass('active');
			this.tabsContainer.find('[name=' + name + ']').addClass('active');
			if (this.tabForm) this.tabForm.destroy();
			this.tabForm = Util.create(this.currentTab.class, [this, this.currentTab.options]);

			this.tabForm.render()
				.appendTo(this.$body);
		}



		// this.tabsContainer.empty();
		//
		// if (!this.pagerTemplates.match(/\/$/)) {
		// 	this.pagerTemplates += "/";
		// }
		//
		// return UI.Template.$render(this.pagerTemplates + this.pagerCurrentPage, {
		// 	widget: this
		// }).appendTo(this.pagerContainer);
	}
});
